import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Avatar,
  Badge,
  IconButton,
  Grid,
  Tooltip,
} from "@material-ui/core";
import * as React from "react";
import { COLOR_PICKER_COLORS } from "../constants/constants";
import TextInputParentComponent from "./TextInputParentComponent";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  handleInputColorSelected: any;
  title: any;
  selectedColor: any;
  colorScheme?: any;
}
class ColorPickerComponent extends React.Component<Props> {
  state = {
    indexSelected: -1,
  };

  componentDidMount = () => {
    this.populateDefault();
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevProps.selectedColor !== this.props.selectedColor) {
      this.populateDefault();
    }
  };

  populateDefault = () => {
    let colors = this.props.colorScheme
      ? this.props.colorScheme
      : COLOR_PICKER_COLORS;
    colors.map((colorObj: any, index: any) => {
      if (colorObj.color === this.props.selectedColor) {
        this.setState({ indexSelected: index });
      }
      return null;
    });
  };

  render() {
    let colors = this.props.colorScheme
      ? this.props.colorScheme
      : COLOR_PICKER_COLORS;
    return (
      <div style={{ marginTop: 10, marginBottom: 10 }}>
        <TextInputParentComponent label={this.props.title}>
          <Grid container justify={"flex-start"}>
            {colors.map((inputColor: any, index: any) => {
              return (
                <IconButton
                  key={index.toString()}
                  onClick={() => {
                    this.setState(
                      {
                        indexSelected: index,
                      },
                      () => {
                        this.props.handleInputColorSelected(
                          inputColor.color,
                          index
                        );
                      }
                    );
                  }}
                >
                  <Tooltip title={inputColor.title}>
                    <Badge
                      variant="dot"
                      invisible={
                        this.state.indexSelected === index ? false : true
                      }
                      color="secondary"
                    >
                      <Avatar
                        style={{
                          backgroundColor: inputColor.color,
                          width: this.state.indexSelected === index ? 35 : 30,
                          height: this.state.indexSelected === index ? 35 : 30,
                        }}
                      >
                        {""}
                      </Avatar>
                    </Badge>
                  </Tooltip>
                </IconButton>
              );
            })}
          </Grid>
        </TextInputParentComponent>
      </div>
    );
  }
}
export default withStyles(styles)(ColorPickerComponent);
